import React from "react";
import { useNavigate } from "react-router-dom";
import HeroSection from "./Home/MainLandingScreen";
import Background from "assets/Home/HomeownerBg.png";
import ManageRepairs from "./Home/ManageRepairs";
import SettingsIcon from "assets/Home/Settings.svg";
import SearchScanIcon from "assets/Home/SearchScan.svg";
import LinkIcon from "assets/Home/Link.svg";
import PersonIcon from "assets/Home/Person.svg";
import ServiceProfessionals from "./Home/ServiceProfessionals";
import LicenseInsurance from "assets/Home/LicenseInsurance.svg";
import Location from "assets/Home/Location.svg";
import Review from "assets/Home/Review.svg";
import Award from "assets/Home/Award.svg";
import HowItWorks from "./Home/PropertyWorlFlow";
import TransparentPricing from "./Home/TransparentPricing";
import HandsOnToFree from "./Home/HandsOnToFree";
import PhoneIcon from "assets/Home/Phone.svg";
import HelpIcon from "assets/Home/HelpCircle.svg";
import CheckCircle from "assets/Home/CheckCircle.svg";
import Globe from "assets/Home/Globe.svg";
import ClockRefresh from "assets/Home/ClockRefresh.svg";
import FaceFrown from "assets/Home/FaceFrown.svg";
import BarChart from "assets/Home/BarChart.svg";
import BankNote from "assets/Home/BankNote.svg";
import FrequentlyAskedQuestions from "./Home/FrequentlyAskedQuestions";
import StayUpdated from "./Home/StayUpdated";
import NoCostModel from "components/Home/NoCostModel.jsx";
const HomeownerLandingPage = () => {
  const navigate = useNavigate();
  const grayIconStyle = { opacity: 0.55 };
  const GetStartedCTA = (props) => (
    <div className="lg:max-w-[1440px] w-full mx-auto">
      <div className="w-full md:px-12 px-5 mt-2 mb-6">
        <button
          onClick={() => navigate("/signup?account_type=HOMEOWNER")}
          style={props.style}
          className="bg-[#47C272] hover:bg-opacity-90 text-white font-medium text-[16px] py-3 px-6 rounded-[8px] transition-all"
        >
          Get Started for Free
        </button>
      </div>
    </div>
  );
  const cards = [
    {
      icon: SettingsIcon,
      title: "We handle maintenance for you",
      description:
        "You submit requests through our system, and we take care of assigning the right vendor. No calls, no back-and-forth,  no stress.",
    },
    {
      icon: PersonIcon,
      title: "The right pro for every problem",
      description:
        "We match you with the right trusted professionals for every repair, ending the endless searches.",
    },
    {
      icon: LinkIcon,
      title: "Everything in one place",
      description:
        "All requests, jobs, and payments are managed through one simple platform. No disorganized texts, emails, or paperwork.",
    },
  ];
  const cardsProfessionals = [
    {
      icon: LicenseInsurance,
      title: "Licensed & Insured",
    },
    {
      icon: Location,
      title: "Locally Vetted",
    },
    {
      icon: Review,
      title: "Highly Rated",
    },
    {
      icon: Award,
      title: "Satisfaction Guarantee",
    },
  ];
  const steps = [
    {
      number: "01",
      basis: "58%",
      title: "Submit a repair request",
      description:
        "You report any issue through Properteasy by providing details, images, and scheduling availability. This gives us everything we need to get started.",
    },
    {
      number: "02",
      basis: "42%",
      title:
        "We assess the issue and broadcast the job to the most suitable vendors",
      description:
        "Properteasy reviews the request, identifies the issue, and assigns it to the most qualified, local professionals.",
    },
    {
      number: "03",
      basis: "100%",
      title: "Vendor accepts the job at a time that works for you",
      description:
        "A qualified vendor reviews the details and accepts the job based upon your availability. You can alternatively provide access instructions so the work can get done, even if nobody’s home.",
    },

    {
      number: "04",
      basis: "40%",
      title: "You're kept in the loop every step of the way",
      description:
        "You receive real-time updates throughout the process so you always know what’s happening, and when.",
    },
    {
      number: "05",
      basis: "60%",
      title: "Pay when the work is completed",
      description:
        "Once the maintenance request is resolved, you’ll receive a final invoice. All payments are made securely and conveniently through Properteasy.",
    },
  ];
  const renderSection = {
    leftSection: [
      {
        icon: PhoneIcon,
        text: "Not knowing who to call and if they’ll even be available",
      },
      {
        text: "Juggling multiple contacts",
        icon: ClockRefresh,
      },
      {
        icon: FaceFrown,
        text: "Multiple jobs, multiple invoices, multiple payment methods",
      },
      {
        icon: HelpIcon,
        text: "Unreliable estimates",
      },
    ],
    rightSection: [
      {
        icon: Globe,
        text: "An expansive vendor network in every service category",
      },
      {
        icon: CheckCircle,
        text: "One point of contact for all your service needs",
      },
      {
        icon: BarChart,
        text: "Centralized Invoicing and payments",
      },
      {
        icon: BankNote,
        text: "Transparent pricing before work begins",
      },
    ],
  };
  return (
    <div
      style={{ marginTop: "96px" }}
      className="flex flex-col justify-center items-center "
    >
      <HeroSection
        background={Background}
        title="No More “Do You Know A Guy?”"
        description="We send trusted, vetted professionals to your home to fix your maintenance issues quickly, so you know who's at your door, what it costs, and that the job will get done right."
        descriptionClassName="md:max-w-[700px]"
        buttonText="Get Started as a Homeowner"
        buttonLink="/signup?account_type=HOMEOWNER"
      />
      <ManageRepairs
        id="property-maintenance-homeowner"
        classFlex="flex gap-8 md:flex-row flex-col  "
        chipTxt="Property Maintenance"
        iconStyle={grayIconStyle}
        cards={cards}
        title="Everything You Need to Manage Repairs Without the Headaches"
        description="We handle repair requests from start to finish, including vendor dispatch and real-time progress updates."
      />
      <GetStartedCTA />
      <ServiceProfessionals
        id="end-to-end-repair-management-homeowner"
        cards={cardsProfessionals}
        iconStyle={grayIconStyle}
        chipText="End-to-End Repair Management"
        title="Service Professionals You Can Trust"
        description="We get it, finding a trusted professional is hard. Properteasy
            removes the guesswork by vetting every service professional before
            they ever reach your door."
      >
        {" "}
        <div className="flex   gap-[10px] text-[#242424] md:flex grid">
          <h2 className="text-[18px] md:text-[22px] bg-[#F6F7F9] w-full p-6 rounded-[20px] ">
            Our rigorous evaluation process includes license and insurance
            verification, as well as client reference validation. Only those who
            demonstrate consistent excellence and reliability are given the
            opportunity to serve our Homeowners.
          </h2>
          <h2 className="text-[18px] md:text-[22px] bg-[#F6F7F9] w-full md:py-6 py-6 px-6 rounded-[20px] ">
            Our screening process is hands on, ensuring only the most
            dependable, skilled, and trustworthy vendors make the cut. Our
            service providers are established local tradesmen with proven track
            records, the professionals you wish you had from the start. With
            Properteasy, now you do.
          </h2>
        </div>
      </ServiceProfessionals>
      <GetStartedCTA />
      <NoCostModel buttonLink="/signup?account_type=HOMEOWNER" />
      <HowItWorks
        id="how-properteasy-works-homeowner"
        chipText="Trusted by 20,000+ members"
        title="Here’s How We Make Repairs Easy"
        steps={steps}
      />
      <TransparentPricing id="pricing-homeowner" />
      <GetStartedCTA />
      <HandsOnToFree buttonLink="/signup?account_type=HOMEOWNER"
        id="what-makes-properteasy-different-homeowner"
        title="Experience True Convenience"
        subTitleone="The Old Way"
        subTitleTwo="With Properteasy"
        leftSection={renderSection.leftSection}
        rightSection={renderSection.rightSection}
      ></HandsOnToFree>
      <FrequentlyAskedQuestions id="faqs-homeowner" />
      <StayUpdated id="stay-updated-homeowner" />
    </div>
  );
};

export default HomeownerLandingPage;
